import PairingModal from './pairing-modal';

export default PairingModal;
